import { graphql } from '@/generated/gql';

export const DELETE_FILTER_MUTATION = graphql(/* GraphQL */ `
  mutation DeleteFilter($id: uuid!) {
    delete_filters_by_pk(id: $id) {
      id
    }
  }
`);
